import { Component, OnInit, Input } from '@angular/core';
import { Barcode, BarcodeQuery, MemberCardQuery, MemberDetails, MemberQuery, PopulationQuery } from '@fgb/core';
import { BarcodeService } from '@fgb/core';
import { Observable } from 'rxjs';
import { MemberCard } from '@fgb/core';
import { config } from '@fgb/core';
import { BalanceQuery } from '@fgb/core';
import { ProductCode } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.scss'],
})
export class BarcodeComponent implements OnInit {
  @Input() memberId: string;
  @Input() primaryTheme: boolean = false;
  @Input() showCashBackToggle: boolean = false;
  @Input() showBarcode: boolean = false;
  @Input() showWallet: boolean = true;
  barcode$: Observable<Barcode>;
  card$: Observable<MemberCard | undefined>;
  member$: Observable<MemberDetails | undefined>;
  memberDetails$: Observable<MemberDetails | undefined>;
  pointsBalance$: Observable<number | undefined>;
  combinedCard$: Observable<number | undefined>;
  productCode = ProductCode;
  isKid: boolean;
  constructor(
    private barcodeService: BarcodeService,
    private barcodeQuery: BarcodeQuery,
    private balanceQuery: BalanceQuery,
    private memberCardQuery: MemberCardQuery,
    private memberDetailsQuery: MemberQuery,
    private memberQuery: MemberQuery,
    private populationQuery: PopulationQuery
  ) {}

  stripSpaces(value: string): string {
    return value ? value.replace(/\s/g, '') : value;
  }

  ngOnInit() {
    this.barcodeService.fetchBarcode().toPromise();
    this.barcode$ = this.barcodeQuery.select();
    this.member$ = this.memberDetailsQuery.selectMemberDetails();
    this.card$ = this.memberCardQuery.selectCurrentCard();
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.combinedCard$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
    this.isKid = this.populationQuery.userInPopulation(['Kids']);
  }
}
